import { render, staticRenderFns } from "./CancelledEntitlement.vue?vue&type=template&id=08b643de&scoped=true&"
import script from "./CancelledEntitlement.vue?vue&type=script&lang=js&"
export * from "./CancelledEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./CancelledEntitlement.vue?vue&type=style&index=0&id=08b643de&prod&lang=scss&scoped=true&"
import style1 from "./CancelledEntitlement.vue?vue&type=style&index=1&id=08b643de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b643de",
  null
  
)

export default component.exports